module.exports = __webpack_public_path__ + "static/media/closedPicture.3c9be97e.svg";